<template>
  <v-container v-if="fund">
    <v-app-bar app color="secondary" dark dense>
      <v-toolbar-title>
        {{ $t("fundEditForm.title", { name: fund.name }) }}
      </v-toolbar-title>
    </v-app-bar>

    <EditForm :id="id" />
  </v-container>
</template>

<script>
import EditForm from "@/components/User/Fund/EditForm";
import FundBaseFormQuery from "@/gql/queries/FundBaseFormQuery.gql";

export default {
  components: {
    EditForm,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      fund: null,
    };
  },

  apollo: {
    fund: {
      query: FundBaseFormQuery,
      variables() {
        return {
          id: this.id,
        };
      },
    },
  },
};
</script>
